export const GET_BUDGETS_BEGIN = 'GET_BUDGETS_BEGIN'
export const GET_BUDGETS_SUCCESS = 'GET_BUDGETS_SUCCESS'
export const GET_BUDGETS_ERROR = 'GET_BUDGETS_ERROR'

export const DELETE_BUDGET_BEGIN = 'DELETE_BUDGET_BEGIN'
export const DELETE_BUDGET_SUCCESS = 'DELETE_BUDGET_SUCCESS'
export const DELETE_BUDGET_ERROR = 'DELETE_BUDGET_ERROR'

export const CREATE_BUDGET_BEGIN = 'CREATE_BUDGET_BEGIN'
export const CREATE_BUDGET_SUCCESS = 'CREATE_BUDGET_SUCCESS'
export const CREATE_BUDGET_ERROR = 'CREATE_BUDGET_ERROR'

export const UPDATE_BUDGET_BEGIN = 'UPDATE_BUDGET_BEGIN'
export const UPDATE_BUDGET_SUCCESS = 'UPDATE_BUDGET_SUCCESS'
export const UPDATE_BUDGET_ERROR = 'UPDATE_BUDGET_ERROR'

export const ADD_STORE_BUDGET_BEGIN = 'ADD_STORE_BUDGET_BEGIN'
export const ADD_STORE_BUDGET_SUCCESS = 'ADD_STORE_BUDGET_SUCCESS'
export const ADD_STORE_BUDGET_ERROR = 'ADD_STORE_BUDGET_ERROR'

export const DELETE_STORE_BUDGET_BEGIN = 'DELETE_STORE_BUDGET_BEGIN'
export const DELETE_STORE_BUDGET_SUCCESS = 'DELETE_STORE_BUDGET_SUCCESS'
export const DELETE_STORE_BUDGET_ERROR = 'DELETE_STORE_BUDGET_ERROR'
